module.exports = __webpack_public_path__ + "static/media/10.ca41e699.webm";